import { DEFAULT_STATE, LICENSE_TYPE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Gets the current licenses value, always returns an array
 * @returns {string[]} - Array of license types, defaults to ["all"] if empty/undefined
 */
const getCurrentLicenses = () => {
  const state = searchPageStore.getState()
  const licenses = state.licenses

  if (!Array.isArray(licenses) || licenses.length === 0) {
    return DEFAULT_STATE.licenses
  }

  return licenses
}

/**
 * Sets the licenses filter
 * @param {string[]} licenses - Either an array with ["all"] or an array of license types
 */
export const setLicenses = (licenses) => {
  if (licenses.includes(LICENSE_TYPE.ALL)) {
    searchPageStore.setState({ licenses: [LICENSE_TYPE.ALL] })
    return
  }

  searchPageStore.setState({ licenses })
}

/**
 * Adds a license type to the array
 * @param {string} license - Either "all" or one of the license types
 */
export const addLicense = (license) => {
  if (license === LICENSE_TYPE.ALL) {
    searchPageStore.setState({ licenses: [LICENSE_TYPE.ALL] })
    return
  }

  const currentLicenses = getCurrentLicenses()

  if (currentLicenses.length === 1 && currentLicenses[0] === LICENSE_TYPE.ALL) {
    searchPageStore.setState({ licenses: [license] })
    return
  }

  if (!currentLicenses.includes(license)) {
    searchPageStore.setState({ licenses: [...currentLicenses, license] })
  }
}

/**
 * Removes a license type from the array
 * @param {string} license - One of the license types (not "all")
 */
export const removeLicense = (license) => {
  const currentLicenses = getCurrentLicenses()

  if (currentLicenses.length === 1 && currentLicenses[0] === LICENSE_TYPE.ALL) {
    return
  }

  const newLicenses = currentLicenses.filter((l) => l !== license)

  searchPageStore.setState({ licenses: newLicenses.length === 0 ? [LICENSE_TYPE.ALL] : newLicenses })
}

/**
 * Clears all licenses
 */
export const clearLicenses = () => {
  searchPageStore.setState({ licenses: DEFAULT_STATE.licenses })
}

// Deliberately not part of clearLicenses: the License dropdown and the More Filters resets call
// it, and a license-only reset must keep the route-default exclude_adult_content in place.
export const clearContentSafetyLicenses = () => {
  searchPageStore.setState({ contentSafetyLicenses: DEFAULT_STATE.contentSafetyLicenses })
}
